var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Camera",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-camera","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M245.5 45H69V31.3c0-2.5-2-4.5-4.5-4.5H38.2c-2.5 0-4.5 2-4.5 4.5V45H4.1c-2.5 0-4.5 2-4.5 4.5v169c0 2.5 2 4.5 4.5 4.5h241.4c2.5 0 4.5-2 4.5-4.5v-169c0-2.5-2-4.5-4.5-4.5zM42.7 35.8H60v7.5H42.7v-7.5zM241 54v46h-72.4c-10.8-12.3-26.4-20-43.8-20s-33 7.7-43.8 20H8.6V54H241zm-76.2 117.4c-9.1 12.6-23.7 20.7-40 20.7-9.5 0-18.3-2.7-25.9-7.5-.7-.4-1.4-.9-2-1.3-13.3-9.3-22.1-25-22.1-42.8 0-.8 0-1.6.1-2.5 0-.3 0-.6.1-1 0-.5.1-1 .1-1.4 0-.4.1-.9.1-1.3 0-.3.1-.7.1-1 .1-.5.1-1 .2-1.5 0-.3.1-.5.1-.8.1-.6.2-1.1.3-1.7 0-.2.1-.3.1-.5.1-.6.3-1.2.4-1.9.7-2.7 1.6-5.3 2.7-7.8.1-.3.2-.5.4-.8.2-.4.3-.7.5-1.1l.6-1.2c.1-.3.3-.5.4-.8.3-.5.5-1 .8-1.4.1-.2.2-.3.3-.5.3-.6.7-1.1 1.1-1.7.1-.1.1-.2.2-.2C92.4 98 107.6 89 124.8 89s32.4 9 41.4 22.7c.1.1.1.2.2.3.4.5.7 1.1 1 1.7.1.2.2.4.3.5.3.5.5.9.8 1.4.1.3.3.5.4.8.2.4.4.8.6 1.1.2.4.4.7.5 1.1.1.3.2.5.3.8 1.4 3.1 2.4 6.4 3.2 9.7 0 .1.1.3.1.4.1.6.2 1.1.3 1.7 0 .2.1.5.1.7.1.5.2 1 .2 1.5 0 .3.1.7.1 1 .1.4.1.9.1 1.3 0 .5.1.9.1 1.4 0 .3.1.7.1 1 0 .8.1 1.6.1 2.5.1 11.5-3.6 22.2-9.9 30.8zM8.6 214V109h65.8c-.5.8-.9 1.6-1.4 2.5-.1.2-.2.3-.3.5-.3.6-.6 1.3-.9 1.9l-.3.6-.9 2.1c-.2.4-.3.8-.5 1.3-.1.3-.2.6-.4 1-.6 1.6-1.2 3.3-1.6 5-.1.2-.1.4-.2.7-.1.6-.3 1.1-.4 1.7 0 .1-.1.3-.1.5-.2 1-.4 2-.6 2.9-.1.4-.1.7-.2 1.1-.1.4-.1.9-.2 1.3-.1.6-.2 1.3-.2 1.9 0 .3-.1.7-.1 1-.1.7-.1 1.4-.2 2.2v.8c0 .9-.1 1.8-.1 2.7 0 26.1 16.2 48.4 38.7 56.9.9.3 1.8.7 2.7 1 5.5 1.8 11.4 2.7 17.5 2.7 20.3 0 38.3-10.6 48.9-26.7 1.1-1.6 2-3.3 3-5 .9-1.7 1.7-3.5 2.5-5.3 3-7.2 4.6-15.2 4.6-23.6 0-.9 0-1.8-.1-2.7v-.8c0-.7-.1-1.4-.2-2.1 0-.4-.1-.8-.1-1.2-.1-.6-.1-1.2-.2-1.8-.1-.5-.1-.9-.2-1.4-.1-.4-.1-.7-.2-1.1-.2-1.1-.4-2.1-.6-3.1 0-.1 0-.2-.1-.3-.1-.6-.3-1.1-.4-1.7-.1-.2-.1-.4-.2-.6-.5-1.7-1-3.4-1.7-5.1l-.3-.9c-.2-.4-.3-.9-.5-1.3-.3-.7-.6-1.3-.9-2-.1-.2-.2-.5-.4-.7l-.9-1.8-.3-.6c-.4-.8-.9-1.6-1.4-2.4h66v105H8.6z"/>
  <path d="M124.8 109.5c-16.7 0-30.3 13.9-30.3 31s13.6 31 30.3 31 30.3-13.9 30.3-31-13.6-31-30.3-31zm0 53.1c-11.7 0-21.3-9.9-21.3-22s9.5-22 21.3-22c11.7 0 21.3 9.9 21.3 22s-9.6 22-21.3 22z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/camera.svg